import { FloatingPanelContent } from "@babackapp/ui/components/floating-panel";


export default function PanelContent({
  title,
  titleSuffix,
  children,
}: {
  title?: string;
  /** Shown right after the title, e.g. an info icon. */
  titleSuffix?: React.ReactNode;
  children: React.ReactNode;
}) {
	return (
		<FloatingPanelContent>
			<div className="flex flex-col gap-2">
        {title && (
          <div className="flex items-center gap-1.5 font-medium text-xs">
            {title}
            {titleSuffix}
          </div>
        )}
				<div className="flex w-full">{children}</div>
			</div>
		</FloatingPanelContent>
	);
}
